import "./Header.css";
import img from './astro.png';
import { Button } from "@material-ui/core";
import {TextField} from "@material-ui/core";
import { useState } from "react";
import { useHistory } from "react-router";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";



const Header = ({name, setName}) => {

    const [error, setError] = useState(false);

    const history = useHistory();

  const submit = () => {
    if (!name) {
      setError(true);
      return;
    } else {
      setError(false);
      history.push("/home");
    }
  
  };


    return( 
        <div className='header'>
            <div className='title'>Welcome to Quiz Box</div>
            <img className='img' src={img}/>
            
        <div className='text'>
          <TextField className="t"
            style ={{left:10, top: 50}}
            label="Enter Your Name"
            variant="outlined"
            onChange={(e) => setName(e.target.value)}
          />

            <Button className="btn"
          style={{background: "black"}}
            variant="contained"
            color="primary"
            size="large"
            onClick={submit}
          >
            Next
          </Button>
          {error && <p className="p">
          !Required
          </p>}
          </div>
        </div>
    )
}

export default Header;
